module.exports = "/static/assets/3b88fb47a568950220f29be12f681ec2.png";